<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.14.0/css/all.min.css" />
<div class="container" style="margin: 18% auto">
	<h1><span class="num">4 </span><i class="fas fa-cog"></i><span class="num"> 4</span></h1>
	<p>Sayfaya Ulaşılamadı.</p>
	<a style="font-size: 15px" href="./auth/sorumlu-girisi">Giriş'e dönmek için tıklayınız.</a>
</div>
